import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { identityText } from "../../locales/en";

export const IsCreditConsentAccepted = (props) => {
  const { kycIdentity, handleOnchange, errorsKycIdentity, handleInfoModal } =
    props;
  return (
    <>
      <p>{identityText?.useAdditionalComp.theWhole}</p>
      <div className="checkbox">
        <div className="d-flex align-items-start">
          <input
            name="kycIdentity"
            type="checkbox"
            id="kyc-consent"
            value={kycIdentity}
            checked={!!kycIdentity}
            onChange={handleOnchange}
            disabled={!!kycIdentity}
          />
          <label htmlFor="kyc-consent">
            {`${identityText?.useAdditionalComp.iConsent} `}
            <Link onClick={handleInfoModal}>
              {identityText?.useAdditionalComp.creditandUdentity}
            </Link>
          </label>
        </div>
        {errorsKycIdentity && (
          <div className="error-text mt-2">{errorsKycIdentity}</div>
        )}
      </div>
    </>
  );
};

IsCreditConsentAccepted.propTypes = {
  kycIdentity: PropTypes.bool,
  handleOnchange: PropTypes.func.isRequired,
  errorsKycIdentity: PropTypes.string,
  handleInfoModal: PropTypes.func.isRequired
};
